import { parseValue } from './utils';

const getBrowserInfo = (ua: string) => {
  const knownBrowsers = [
    { name: 'Yandex', regex: /YaBrowser\/(\d+)/ },
    { name: 'Samsung', regex: /SamsungBrowser\/(\d+)/ },
    { name: 'UC Browser', regex: /UCBrowser\/(\d+)/ },
    { name: 'Opera', regex: /(OPR|Opera)\/(\d+)/ },
    { name: 'Microsoft Legacy Edge', regex: /Edge\/(\d+)/ },
    { name: 'Microsoft Edge', regex: /Edg\/(\d+)/ },
    { name: 'Microsoft Internet Explorer', regex: /(MSIE|rv)\s?(\d+)/ },
    { name: 'Chrome', regex: /Chrome\/(\d+)/ },
    { name: 'Safari', regex: /Version\/(\d+)/ },
    { name: 'Firefox', regex: /Firefox\/(\d+)/ },
  ];

  for (const browser of knownBrowsers) {
    if (browser.regex.test(ua)) {
      const version = browser.regex.exec(ua)?.[1] ?? '-';
      return { name: browser.name, version };
    }
  }
  return { name: 'Unknown', version: '-' };
};

const getOsInfo = (ua: string) => {
  const osMap = [
    { name: 'Windows', regex: /Windows (.*)/ },
    { name: 'Mac OS X', regex: /Mac OS X (\d+[._]\d+)/ },
    { name: 'Android', regex: /Android (\d+[._]\d+)/ },
    { name: 'iOS', regex: /OS (\d+)_(\d+)_?(\d+)?/ },
    { name: 'Linux', regex: /Linux/ },
  ];

  for (const os of osMap) {
    if (os.regex.test(ua)) {
      let version = parseValue(os.regex.exec(ua)?.[1], '-');
      if (os.name === 'iOS') {
        const match = /OS (\d+)_?(\d+)?_?(\d+)?/.exec(ua);
        version = match ? `${match[1]}.${match[2] || 0}.${match[3] || 0}` : '-';
      }
      return { name: os.name, version };
    }
  }
  return { name: 'Unknown', version: '-' };
};

export const getClientInfo = () => {
  const ua = navigator.userAgent;
  const screenSize = window.screen.width
    ? `${window.screen.width} x ${window.screen.height}`
    : '-';
  const browserInfo = getBrowserInfo(ua);
  const osInfo = getOsInfo(ua);
  const isMobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(ua);
  let cookieEnabled = navigator.cookieEnabled || false;

  if (!cookieEnabled) {
    try {
      const baseCookie = 'testcookie=1;samesite=strict;path=/';
      document.cookie =
        window.location?.protocol === 'https:'
          ? `${baseCookie};secure`
          : baseCookie;
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    } catch {
      cookieEnabled = false;
    }
  }

  return {
    os: `${osInfo.name} ${osInfo.version}`,
    browser: `${browserInfo.name} ${browserInfo.version}`,
    deviceType: isMobile ? 'MOBILE' : 'DESKTOP',
    cookieEnabled,
    screenSize,
    userAgent: ua,
  };
};
